import { Link } from "react-router-dom";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { Bars3Icon, PhoneIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { HashLink } from "react-router-hash-link";

export default function SiteHeader() {
  return (
    <header className="absolute top-0 inset-x-0 z-50 bg-[#FCFBF6] border-b border-gray-100">
      <div
        className="
          flex mx-auto items-center justify-between
          px-6 lg:px-10 py-4
          max-w-[1200px]
          md:max-w-[1280px]
          lg:max-w-[1400px]
          xl:max-w-[1600px]
          2xl:max-w-[1720px]
        "
      >
        {/* Logo + Nav */}
        <div className="flex justify-start gap-10">
          {/* Logo */}
          <Link to="/" className="flex">
            <img
              src="/heartlandlogo.png"
              alt="Heartland Property Solutions Logo"
              className="h-8 md:h-10 lg:h-9 w-auto"
            />
          </Link>

          {/* Nav links (left aligned, next to logo) */}
          <nav className="hidden lg:flex items-center gap-8">
            <Link
              to="/owners"
              className="text-sm font-medium text-gray-900 hover:text-black"
            >
              For Owners
            </Link>
            <Link
              to="/owners#team"
              className="text-sm font-medium text-gray-900 hover:text-black"
            >
              Our Team
            </Link>
            <HashLink
              smooth
              to="/#whereWeServe"
              className="text-sm font-medium text-gray-900 hover:text-black"
            >
              Service Map
            </HashLink>
            <HashLink
              to="/#aboutUs"
              className="text-sm font-medium text-gray-900 hover:text-black"
            >
              About Us
            </HashLink>
          </nav>
        </div>

        {/* CTAs (far right) */}
        <div className="hidden lg:flex items-center gap-4">
          {/* <a
            href="https://heartlandpropertysolutions.appfolio.com/connect"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-md bg-[#F9DC5C] px-5 py-2 text-sm font-semibold text-black hover:brightness-95 transition"
          >
            <PhoneIcon className="h-4 w-4" />
            Call Now (785-844-0502)
          </a> */}
          <a
            href="https://heartlandpropertysolutions.appfolio.com/connect"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-md bg-[#F9DC5C] px-5 py-2 text-sm font-semibold text-black hover:brightness-95 transition"
          >
            Pay Rent
          </a>
          <a
            href="https://heartlandpropertysolutions.appfolio.com/connect"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-gray-900 inline-flex items-center gap-1"
          >
            Owner Portal →
          </a>
        </div>

        {/* Mobile Menu */}
        <div className="lg:hidden ml-auto">
          <Popover>
            {({ open }) => (
              <>
                <PopoverButton className="inline-flex items-center justify-center rounded-md p-2 text-gray-900 hover:bg-gray-100">
                  {open ? (
                    <XMarkIcon className="h-6 w-6" />
                  ) : (
                    <Bars3Icon className="h-6 w-6" />
                  )}
                </PopoverButton>

                <PopoverPanel className="absolute left-0 right-0 top-full z-50 px-6 pt-3">
                  <div
                    className="mx-auto rounded-2xl border border-gray-200 bg-white p-6 shadow-lg
                                  max-w-[1200px] md:max-w-[1280px] lg:max-w-[1400px] xl:max-w-[1600px] 2xl:max-w-[1720px]"
                  >
                    <nav className="flex flex-col gap-4 text-[#2B2B2B]">
                      <Link to="/contact" className="hover:text-black">
                        Contact Us
                      </Link>
                      <Link to="/owners" className="hover:text-black">
                        Owners
                      </Link>
                      <Link to="/benefits" className="hover:text-black">
                        Benefits
                      </Link>
                      <a href="#learn" className="hover:text-black">
                        Learn
                      </a>

                      <div className="mt-4 flex flex-col gap-3">
                        <a
                          href="https://heartlandpropertysolutions.appfolio.com/connect"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="rounded-md bg-[#F9DC5C] px-5 py-2 text-sm font-semibold text-black text-center hover:brightness-95 transition"
                        >
                          Pay Rent
                        </a>
                        <a
                          href="https://heartlandpropertysolutions.appfolio.com/connect"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm font-semibold text-gray-900 text-center"
                        >
                          Owner Portal →
                        </a>
                      </div>
                    </nav>
                  </div>
                </PopoverPanel>
              </>
            )}
          </Popover>
        </div>
      </div>
    </header>
  );
}
